angular.module('iconoglobe')
.service('toastService', ["$timeout", function($timeout){
  
  this.create = function(mess, pos, customClass, timeout ){
    angular.element(".toast").remove();
    angular.element('body').append("<p class='toast "+ pos +" " + customClass +"'>"+ mess +"</p>");
    var toast = angular.element(".toast");
    $timeout(function(){
      angular.element(toast).addClass('show');
    },100);
    
    $timeout(function(){
      angular.element(toast).remove();
    }, timeout)
  }
  
}]);
